import { useAlertsParams } from "../../../hooks/useAlertsParams";
import type { AlertTabId } from "../../tabs/config";

/**
 * Secondary domains in the competitor filter are only meaningful for tabs whose
 * datasets are sourced from the secondary-list pipeline (News, Social Posts,
 * Website Content). For Ads and SEO the BE only supports primary competitors,
 * so the dropdown disables those rows and the query hooks strip them out before
 * issuing requests.
 */
const SECONDARY_DISALLOWED_TABS = new Set<AlertTabId>(["ads", "seoAlerts"]);

export const useIsSecondaryDomainsAllowed = (): boolean => {
    const { tab } = useAlertsParams();

    if (!tab) {
        return true;
    }

    return !SECONDARY_DISALLOWED_TABS.has(tab);
};
